export default function LinearSkill({ label, detail, value }) {
  return (
    <div className="col-lg-6">
      <div className="mil-lang-skills-item mil-mb-30">
        <h6 className="mil-mb-10 skill-label">
          {label}:<span>{detail}</span>
        </h6>
        <div className="mil-line-progress">
          <div className="mil-bar" style={{ width: `${value}%` }} data-value={`${value}%`}></div>
        </div>
      </div>
    </div>
  )
}
